import { render, staticRenderFns } from "./CompletedAffiliatedList.vue?vue&type=template&id=d0f263bc&"
import script from "./CompletedAffiliatedList.vue?vue&type=script&lang=ts&"
export * from "./CompletedAffiliatedList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports